import React from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, MessageSquareIcon, AlertTriangleIcon } from 'lucide-react';
export function Contact() {
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-103">
      <PageHeader title="Contact Us" subtitle="Free consultation available" showBack={true} data-id="element-104" />

      <main className="px-4 py-6" data-id="element-105">
        {/* Lawyer Card */}
        <motion.div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-5 mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-106">
          <div className="flex items-center gap-4 mb-4" data-id="element-107">
            <div className="w-20 h-20 rounded-2xl bg-[#252525] flex items-center justify-center overflow-hidden" data-id="element-108">
              <span className="text-4xl" data-id="element-109">👨‍⚖️</span>
            </div>
            <div data-id="element-110">
              <h2 className="text-xl font-bold text-white" data-id="element-111">Jason Waechter</h2>
              <p className="text-[#d4a853] text-sm font-medium" data-id="element-112">
                The Motorcycle Lawyer
              </p>
              <p className="text-[#a3a3a3] text-xs mt-1" data-id="element-113">
                Michigan Motorcycle Law Specialist
              </p>
            </div>
          </div>

          {/* Credentials */}
          <div className="flex items-center gap-3 bg-[#252525] rounded-xl p-3" data-id="element-114">
            <div className="w-12 h-12 rounded-lg bg-[#d4a853]/10 flex items-center justify-center" data-id="element-115">
              <span className="text-2xl" data-id="element-116">🏆</span>
            </div>
            <div data-id="element-117">
              <p className="text-white font-semibold text-sm" data-id="element-118">Best Law Firms</p>
              <p className="text-[#a3a3a3] text-xs" data-id="element-119">U.S. News & World Report</p>
            </div>
          </div>
        </motion.div>

        {/* Emergency Contact */}
        <motion.a href="tel:+18005551234" className="block bg-[#dc2626] rounded-2xl p-4 mb-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} whileTap={{
        scale: 0.98
      }} data-id="element-120">
          <div className="flex items-center gap-4" data-id="element-121">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-122">
              <AlertTriangleIcon className="w-6 h-6 text-white" data-id="element-123" />
            </div>
            <div className="flex-1" data-id="element-124">
              <p className="text-white font-bold" data-id="element-125">Emergency Line</p>
              <p className="text-white/80 text-sm" data-id="element-126">24/7 Accident Response</p>
            </div>
            <PhoneIcon className="w-6 h-6 text-white" data-id="element-127" />
          </div>
        </motion.a>

        {/* Contact Options */}
        <motion.div className="space-y-3 mb-6" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} data-id="element-128">
          <a href="tel:+18005551234" className="flex items-center gap-4 bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 active:bg-[#252525]" data-id="element-129">
            <div className="w-12 h-12 bg-[#22c55e]/10 rounded-xl flex items-center justify-center" data-id="element-130">
              <PhoneIcon className="w-6 h-6 text-[#22c55e]" data-id="element-131" />
            </div>
            <div className="flex-1" data-id="element-132">
              <p className="text-white font-semibold" data-id="element-133">Call Us</p>
              <p className="text-[#a3a3a3] text-sm" data-id="element-134">1-800-555-1234</p>
            </div>
          </a>

          <a href="mailto:jason@motorcyclelawyer.com" className="flex items-center gap-4 bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 active:bg-[#252525]" data-id="element-135">
            <div className="w-12 h-12 bg-[#3b82f6]/10 rounded-xl flex items-center justify-center" data-id="element-136">
              <MailIcon className="w-6 h-6 text-[#3b82f6]" data-id="element-137" />
            </div>
            <div className="flex-1" data-id="element-138">
              <p className="text-white font-semibold" data-id="element-139">Email</p>
              <p className="text-[#a3a3a3] text-sm" data-id="element-140">
                jason@motorcyclelawyer.com
              </p>
            </div>
          </a>

          <a href="sms:+18005551234" className="flex items-center gap-4 bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 active:bg-[#252525]" data-id="element-141">
            <div className="w-12 h-12 bg-[#a855f7]/10 rounded-xl flex items-center justify-center" data-id="element-142">
              <MessageSquareIcon className="w-6 h-6 text-[#a855f7]" data-id="element-143" />
            </div>
            <div className="flex-1" data-id="element-144">
              <p className="text-white font-semibold" data-id="element-145">Text Us</p>
              <p className="text-[#a3a3a3] text-sm" data-id="element-146">Quick questions welcome</p>
            </div>
          </a>
        </motion.div>

        {/* Office Info */}
        <motion.div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 mb-6" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} data-id="element-147">
          <h3 className="text-white font-semibold mb-3" data-id="element-148">Office Location</h3>
          <div className="space-y-3" data-id="element-149">
            <div className="flex items-start gap-3" data-id="element-150">
              <MapPinIcon className="w-5 h-5 text-[#d4a853] mt-0.5" data-id="element-151" />
              <div data-id="element-152">
                <p className="text-white text-sm" data-id="element-153">123 Legal Drive, Suite 100</p>
                <p className="text-[#a3a3a3] text-sm" data-id="element-154">Detroit, MI 48226</p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-155">
              <ClockIcon className="w-5 h-5 text-[#d4a853] mt-0.5" data-id="element-156" />
              <div data-id="element-157">
                <p className="text-white text-sm" data-id="element-158">Mon-Fri: 9am - 6pm</p>
                <p className="text-[#a3a3a3] text-sm" data-id="element-159">
                  24/7 Emergency Line Available
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Free Consultation CTA */}
        <motion.div className="bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} data-id="element-160">
          <p className="text-[#d4a853] font-bold text-lg mb-2" data-id="element-161">
            Free Consultation
          </p>
          <p className="text-[#a3a3a3] text-sm mb-4" data-id="element-162">
            Been in an accident? We'll review your case at no cost. You don't
            pay unless we win.
          </p>
          <a href="tel:+18005551234" className="inline-flex items-center gap-2 bg-[#d4a853] text-black font-semibold px-6 py-3 rounded-xl" data-id="element-163">
            <PhoneIcon className="w-5 h-5" data-id="element-164" />
            Schedule Now
          </a>
        </motion.div>
      </main>
    </div>;
}